import { Injectable } from "@angular/core";
import {
  FileSystemFolderDetails,
  FileSystemService
} from "../../../../../../../swaggerServices";
import { AttachmentRef } from "../../../urls";

export type Folders = {
  rootFolder: string;
  attachmentsFolder: string;
  targetFolder: string;
}

export const initFolders = (): Folders => ({
  rootFolder: "",
  attachmentsFolder: "",
  targetFolder: "",
});

@Injectable({ providedIn: 'root' })
export class AttachmentsService {
  private static readonly ATTACHMENTS_FOLDER = "Attachments";

  constructor(
    private fileSystemService: FileSystemService
  ) { }

  setRootFolder(folders: Folders, rootFolder: string) {
    const [protocol, folderLink] = rootFolder.split("://");
    this.fileSystemService.fileSystemGetFolderDetailFromLinkPut({ folderLink, protocol }).subscribe(
      (response: FileSystemFolderDetails) => {
        folders.rootFolder = response.folderMetaData?.id ?? "";
        folders.attachmentsFolder = response.folderChildren?.filter(f => f.name === AttachmentsService.ATTACHMENTS_FOLDER)[0]?.id ?? "";
      }
    );
  }

  async uploadAttachments(folders: Folders, folderName: string, attachments: File[]): Promise<{ attachments: AttachmentRef[], success: boolean }> {
    folderName = folderName.replace(/\//g, "_"); // Remove forward slashes as it causes path problems
    if (attachments.length === 0) return {attachments: [], success: true};
    if (!folders.attachmentsFolder) {
      const res = await this.fileSystemService.fileSystemCreateFolderPut({ folderName: AttachmentsService.ATTACHMENTS_FOLDER, folderId: folders.rootFolder }).toPromise();
      folders.attachmentsFolder = res.folderChildren?.filter(f => f.name === AttachmentsService.ATTACHMENTS_FOLDER)[0]?.id ?? "";
    }
    if (!folders.targetFolder) {
      const res = await this.fileSystemService.fileSystemCreateFolderPut({ folderName, folderId: folders.attachmentsFolder }).toPromise();
      folders.targetFolder = res.folderChildren?.filter(f => f.name === folderName)[0]?.id ?? "";
    }
    let before = (await this.fileSystemService.fileSystemGetFolderDetailPut({ folderId: folders.targetFolder }).toPromise()).folderChildren?.map(c => c.id) ?? [];
    const uploadedAttachmentsById = new Map<string, AttachmentRef>();
    let success = true;
    for (let a of attachments) {
      try {
        const response = await this.fileSystemService.fileSystemUploadDocumentPost(a, folders.targetFolder).toPromise();
        const afterChildren = response.folderChildren || [];
        const after = afterChildren.map(c => c.id).filter((id): id is string => !!id) ?? [];
        const newIds = after.filter(id => !before.includes(id));

        for (const id of newIds) {
          const uploadedChild = afterChildren.find(c => c.id === id);
          const fileName = uploadedChild?.name || a.name;
          const extension = ((uploadedChild?.extension || fileName.split(".").pop()) || "").toLowerCase();
          uploadedAttachmentsById.set(id, { id, fileName, extension });
        }
        before = after;
      } catch (e) {
        success = false;
        break;
      };
    }

    return { attachments: Array.from(uploadedAttachmentsById.values()), success };
  }
}
